/**
 * Labstep
 *
 * @module components/Group/Action/SetIsInviteOnly
 * @desc Set isInviteOnly for Group
 */

import { EntityActionUpdateCheckbox } from 'labstep-web/components/Entity/Action/Update/Checkbox';
import type React from 'react';
import type { GroupActionSetIsInviteOnlyProps } from './types';

export const GroupActionSetIsInviteOnly: React.FC<
  GroupActionSetIsInviteOnlyProps
> = ({ group }) => (
  <EntityActionUpdateCheckbox
    entity={group}
    field={'is_invite_only' as const}
    toggle
    optimistic
  />
);
